let customTheme

const setCustomTheme = (theme) => {
  customTheme = theme;
}

const lightTheme = () => {
  return {
    palette: {
      mode: 'light',
      primary: {
        main: '#0072DE',
        contrastText: '#FFFFFF'
      },
      secondary: {
        main: 'rgba(0, 0, 0, 0.06)',
        contrastText: '#252525'
      },
      background: {
        paper: '#FCFCFC'
      },
      text: {
        secondary: '#8F8F8F'
      },
      ...customTheme?.palette
    },
    breakpoints: {
      ...customTheme?.breakpoints
    },
    typography: {
      ...customTheme?.typography
    },
    components: {
      MuiBottomNavigation: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: 18,
            fontWeight: 500,
            backgroundColor: '#F6F6F6',
            color:'#010101',
            minHeight: 60
          }
        }
      },
      MuiBottomNavigationAction : {
        styleOverrides: {
          root: {
            minWidth: "auto",
            maxWidth: "100%",
            color:'#010101',
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 500,
            fontSize: 15
          },
          startIcon: {
            marginRight: 'auto'
          }
        }
      },
      ...customTheme?.components
    }
  }
}

const darkTheme = () => {
  return {
    palette: {
      mode: 'dark',
      primary: {
        main: '#0381FE',
        contrastText: '#FAFAFA'
      },
      secondary: {
        main: '#5D5D5D',
        contrastText: '#FAFAFA'
      },
      background: {
        paper: '#171717'
      },
      text: {
        secondary: '#8F8F8F'
      },
      ...customTheme?.palette
    },
    breakpoints: {
      ...customTheme?.breakpoints
    },
    typography: {
      ...customTheme?.typography
    },
    components: {
      MuiBottomNavigation: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: 18,
            fontWeight: 500,
            backgroundColor: '#010101',
            color:'#FAFAFA',
            minHeight: 60
          }
        }
      },
      MuiBottomNavigationAction : {
        styleOverrides: {
          root: {
            minWidth: "auto",
            maxWidth: "100%"
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 500,
            fontSize: 15
          },
          startIcon: {
            marginRight: 'auto'
          }
        }
      },
      ...customTheme?.components
    }
  }
}

export { setCustomTheme, lightTheme, darkTheme }
